import { render, staticRenderFns } from "./favorite-badge.vue?vue&type=template&id=7bf516e4&scoped=true"
import script from "./favorite-badge.vue?vue&type=script&lang=js"
export * from "./favorite-badge.vue?vue&type=script&lang=js"
import style0 from "./favorite-badge.vue?vue&type=style&index=0&id=7bf516e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf516e4",
  null
  
)

export default component.exports